import PropTypes from 'prop-types'

import { mergeOverrides } from 'baseui'
import { Modal, ModalBody, ROLE, SIZE } from 'baseui/modal'

import { ModalContent, ModalSections, ModalTitle, SDModalOverrides, SDModalPulseOverrides } from './styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const SDModal = ({ isOpen, openHandler, sections, title, overrides }) => {
  const isPulse = usePulseScope()
  const baseOverrides = isPulse ? SDModalPulseOverrides() : SDModalOverrides()

  return (
    <Modal
      autoFocus={false}
      onClose={() => openHandler(false)}
      closeable
      isOpen={isOpen}
      animate
      size={SIZE.default}
      role={ROLE.dialog}
      returnFocus={false}
      overrides={mergeOverrides(baseOverrides, overrides ?? {})}
    >
      <ModalBody>
        <ModalTitle $pulse={isPulse}>{title}</ModalTitle>
        <ModalContent>
          <ModalSections>{sections}</ModalSections>
        </ModalContent>
      </ModalBody>
    </Modal>
  )
}

SDModal.propTypes = {
  backgroundImage: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  isOpen: PropTypes.bool.isRequired,
  openHandler: PropTypes.func.isRequired,
  sections: PropTypes.object,
  title: PropTypes.string,
  overrides: PropTypes.object,
}

export default SDModal
